import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Button, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import http from "../services/httpService";
import {
  getDate,
  prospectDetailsPath,
  toHHMMSS,
  getTime,
  getDateTime,
  investmentDetailsPath,
  maskMobile,
  referralManagerPath,
  searchFilter,
  handleSort,
  emailMask,
} from "../utils/varialbles";
import { useHistory, useRouteMatch } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
});
function ReferralDashboard() {
  const location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(true);
  const [totalAmount, setTotalAmount] = useState({});
  const [refSectionVisitDates, setRefSectionVisitDates] = useState([]);
  const [refereeVisitsUserIDs, setrefereeVisitsUserIDs] = useState([]);
  const [successfulReferralsData, setSuccessfulReferralsData] = useState([]);
  const [ProspectBasicInfo, setProspectBasicInfo] = useState({});
  const [refsectionVisitCount, setRefsectionVisitCount] = useState(0);
  const [refereesVisitsCount, setRefereesVisitsCount] = useState(0);
  const [referralsShared, setReferralsShared] = useState(0);
  const [referralsSharedDates, setreferralsSharedDates] = useState([]);
  const [successfulReferralsCount, setSuccessfulReferralsCount] = useState(0);
  const [referralHistory, setReferralHistory] = useState([]);
  const myparam = location.state;
  useEffect(() => {
    if (
      myparam &&
      (myparam.cust__id || myparam.customer_id || myparam.cust_id)
    ) {
      let cust_id = myparam.cust__id || myparam.customer_id || myparam.cust_id;
      http
        .get("/referral_dashboard/" + cust_id)
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.Prospect_Basic_info &&
            Array.isArray(res.data.Prospect_Basic_info) &&
            res.data.Prospect_Basic_info.length > 0
          ) {
            setProspectBasicInfo(res.data.Prospect_Basic_info[0]);
          }
          if (
            res &&
            res.data &&
            res.data.Referral_Data &&
            Array.isArray(res.data.Referral_Data) &&
            res.data.Referral_Data.length > 0
          ) {
            if (res.data.Referral_Data[0]["refsection_visit_count"]) {
              setRefsectionVisitCount(
                res.data.Referral_Data[0]["refsection_visit_count"]
              );
            } else {
              setRefsectionVisitCount(0);
            }
            if (res.data.Referral_Data[0]["Referrals_Shared"]) {
              setReferralsShared(res.data.Referral_Data[0]["Referrals_Shared"]);
            } else {
              setReferralsShared(0);
            }
            if (res.data.Referral_Data[0]["referees_visits_count"]) {
              setRefereesVisitsCount(
                res.data.Referral_Data[0]["referees_visits_count"]
              );
            } else {
              setRefereesVisitsCount(0);
            }
            if (res.data.Referral_Data[0]["successful_referrals_count"]) {
              setSuccessfulReferralsCount(
                res.data.Referral_Data[0]["successful_referrals_count"]
              );
            } else {
              setSuccessfulReferralsCount(0);
            }
            if (
              res.data.Referral_Data[0]["Total_amount"] &&
              res.data.Referral_Data[0]["Total_amount"]["earnings__sum"]
            ) {
              setTotalAmount(res.data.Referral_Data[0]["Total_amount"]);
            } else {
              setTotalAmount({});
            }
            if (
              res.data.Referral_Data[0]["referee_visits_UserIDs"] &&
              Array.isArray(
                res.data.Referral_Data[0]["referee_visits_UserIDs"]
              ) &&
              res.data.Referral_Data[0]["referee_visits_UserIDs"].length > 0
            ) {
              setrefereeVisitsUserIDs(
                res.data.Referral_Data[0]["referee_visits_UserIDs"]
              );
            } else {
              setrefereeVisitsUserIDs([]);
            }
            if (
              res.data.Referral_Data[0]["Referrals_shared_dates"] &&
              Array.isArray(
                res.data.Referral_Data[0]["Referrals_shared_dates"]
              ) &&
              res.data.Referral_Data[0]["Referrals_shared_dates"].length > 0
            ) {
              setreferralsSharedDates(
                res.data.Referral_Data[0]["Referrals_shared_dates"]
              );
            } else {
              setreferralsSharedDates([]);
            }
            if (
              res.data.Referral_Data[0]["refsection_visit_dates"] &&
              Array.isArray(
                res.data.Referral_Data[0]["refsection_visit_dates"]
              ) &&
              res.data.Referral_Data[0]["refsection_visit_dates"].length > 0
            ) {
              setRefSectionVisitDates(
                res.data.Referral_Data[0]["refsection_visit_dates"]
              );
            } else {
              setRefSectionVisitDates([]);
            }
            if (
              res.data.Referral_Data[0]["successful_referrals_data"] &&
              Array.isArray(
                res.data.Referral_Data[0]["successful_referrals_data"]
              ) &&
              res.data.Referral_Data[0]["successful_referrals_data"].length > 0
            ) {
              setSuccessfulReferralsData(
                res.data.Referral_Data[0]["successful_referrals_data"]
              );
            } else {
              setSuccessfulReferralsData([]);
            }
            if (
              res.data.Referral_Data[0]["referral_history"] &&
              Array.isArray(res.data.Referral_Data[0]["referral_history"]) &&
              res.data.Referral_Data[0]["referral_history"].length > 0
            ) {
              setReferralHistory(res.data.Referral_Data[0]["referral_history"]);
            } else {
              setReferralHistory([]);
            }
          }
        })
        .catch((err) => { });
    }
  }, []);
  const gotoProspectDetails = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.cust_id) {
      history.push({
        state: { page: myparam.page },
        pathname: referralManagerPath
      });
    }
  };

  // (myparam);

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
      style={showWindow ? { display: "block" } : { display: "none" }}
      className="pb30"
    >
      <Paper className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={6} md={1} className="overviewbar">
            <Button
              name="Overview"
              variant="contained"
              color="primary"
              onClick={gotoProspectDetails}
            >
              Overview
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Grid container style={{ marginTop: "10px" }}>
        <Grid
          item
          xs={false}
          sm={6}
          md={4}
          style={{ marginTop: 30 }}
          className="overviewbar"
        >
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid
          item
          xs={false}
          sm={6}
          md={6}
          style={{ marginTop: 30 }}
          className="overviewbar"
        >
          <Typography color="textPrimary" variant="h5">
            Referral Dashboard
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: "20px" }} >
        <Grid item xs={12} sm={6} md={4} lg={2} className="overviewbar">
          <Typography variant="body1">User ID</Typography>
          <Typography variant="h6">{ProspectBasicInfo.UserID}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2} className="overviewbar">
          <Typography variant="body1">Name</Typography>
          <Typography variant="h6">{ProspectBasicInfo.Name}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2} className="overviewbar">
          <Typography variant="body1">Mobile Number</Typography>
          <Typography variant="h6">{maskMobile(ProspectBasicInfo.mobile)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} className="overviewbar">
          <Typography variant="body1">Email ID</Typography>
          <Typography variant="h6">{emailMask(ProspectBasicInfo.EmailID)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2} className="overviewbar">
          <Typography variant="body1">Referral Code</Typography>
          <Typography variant="h6">{ProspectBasicInfo.Referral_Code}</Typography>
        </Grid>
      </Grid>

      {/* 
            <Grid container className="mt30">
                <Grid item xs={12} sm={2} md={2} >
                    <Grid item xs={12} sm={12} md={12} className="overviewbar">

                        <Typography  color="textPrimary" variant="caption" >
                            Referral Section Visits
                        </Typography>
                        
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} className="overviewbar">

                        <Typography  color="textPrimary" variant="h6" >
                            {refsectionVisitCount}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} className={"overviewbar"}>

                        <Typography  color="textPrimary" variant="body1" >
                            Date and Time
                        </Typography>
                    </Grid>
                    {
                        refSectionVisitDates.map((date, inx) => {
                            return (
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: 20 }} key={inx + "dt"} className={"overviewbar","mt30"}>
                                    <Typography  color="textPrimary" variant="body2" >
                                        {getDateTime(date)}
                                    </Typography>
                                </Grid>
                            )
                        })
                    }
                </Grid>
                <Grid item xs={12} sm={2} md={2} className="mt30" >
                    <Grid item xs={12} sm={12} md={12} className="overviewbar">

                        <Typography  color="textPrimary" variant="caption" >
                            Referrals Shared
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} className="overviewbar" >

                        <Typography  color="textPrimary" variant="h6" >
                            {referralsShared}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} className={"overviewbar"}>

                        <Typography  color="textPrimary" variant="body1" >
                            Date
                        </Typography>
                    </Grid>
                    <Grid className="overviewbar">
                    {
                        referralsSharedDates.map((date, inx) => {
                            return (
                                <Grid item xs={12} sm={12} md={12} style={{ marginTop: 20 }} key={inx + "dt"} >
                                    <Typography  color="textPrimary" variant="body2" >
                                        {getDate(date['createddt'])}
                                    </Typography>
                                </Grid>
                            )
                        })
                    }
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={2} md={2} className="mt30">
                    <Grid item xs={12} sm={12} md={12} >

                        <Typography  color="textPrimary" variant="caption" >
                            Referees visits or downloads
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} >

                        <Typography  color="textPrimary" variant="h6" >
                            {refereesVisitsCount}
                        </Typography>
                    </Grid>
                    <Grid container className="mt30">
                        <Grid item xs={12} sm={6} md={6} >

                            <Typography  color="textPrimary" variant="body1" >
                                User ID
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} >

                            <Typography  color="textPrimary" variant="body1" >
                                Response
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        refereeVisitsUserIDs.map((data, inx) => {
                            return (
                                <Grid container style={{ marginTop: 20 }} key={inx + "refereeVisitsUserIDs"}>
                                    <Grid item xs={12} sm={6} md={6}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data.UserID}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data["Sign Up"]}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Grid>
                <Grid item xs={12} sm={4} md={4} className={"mt30"}>
                    <Grid item xs={12} sm={12} md={12} >

                        <Typography  color="textPrimary" variant="caption" >
                            Successful Referrals
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} >

                        <Typography  color="textPrimary" variant="h6" >
                            {successfulReferralsCount}
                        </Typography>
                    </Grid>
                    <Grid container className="mt30">
                        <Grid item xs={12} sm={4} md={4} >

                            <Typography  color="textPrimary" variant="body1" >
                                Amount
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} >

                            <Typography  color="textPrimary" variant="body1" >
                                Date and Time
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} >

                            <Typography  color="textPrimary" variant="body1" >
                                User ID
                            </Typography>
                        </Grid>
                    </Grid>
                    {
                        successfulReferralsData.map((data, inx) => {
                            return (
                                <Grid container style={{ marginTop: 20 }} key={inx + "successfulReferralsData"}>
                                    <Grid item xs={12} sm={4} md={4}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data.UserID}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {getDateTime(data["Datetime"])}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data["UserID"]}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid> */}

      {/* {
                        refSectionVisitDates.map((date, inx) => {
                            return (
                                <div item xs={12} sm={12} md={12} style={{ marginTop: 20 }} key={inx + "dt"} className={"overviewbar","mt30"}>
                                    <Typography  color="textPrimary" variant="body2" >
                                        {getDateTime(date)}
                                    </Typography>
                                </div>
                            )
                        })
                    } */}

      {/* {
                        refereeVisitsUserIDs.map((data, inx) => {
                            return (
                                <div key={inx + "refereeVisitsUserIDs"}>
                                    <div item xs={12} sm={6} md={6}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data.UserID}
                                        </Typography>
                                    </div>
                                    <div item xs={12} sm={6} md={6}  >
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data["Sign Up"]}
                                        </Typography>
                                    </div>
                                </div>
                            )
                        })
                    } */}

      {/* {
                        successfulReferralsData.map((data, inx) => {
                            return (
                                <div container style={{ marginTop: 20 }} key={inx + "successfulReferralsData"}>
                                    <div>
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data.UserID}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography  color="textPrimary" variant="body2" >
                                            {getDateTime(data["Datetime"])}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography  color="textPrimary" variant="body2" >
                                            {data["UserID"]}
                                        </Typography>
                                    </div>
                                </div>
                            )
                        })
                    } */}

      <div className="acc_parent">
        <Accordion className="accordian">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>
              Referral section visists
            </Typography>
            <div>{refsectionVisitCount}</div>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      Date and Time
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  <TableRow>
                    <TableCell>
                      {refSectionVisitDates.map((date, inx) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ marginTop: 20 }}
                            key={inx + "dt"}
                            className={("overviewbar", "mt30")}
                          >
                            <Typography color="textPrimary" variant="body2">
                              {getDateTime(date)}
                            </Typography>
                          </Grid>
                        );
                      })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* <Typography>
            Date and Time
            {refSectionVisitDates.map((date, inx) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: 20 }}
                  key={inx + "dt"}
                  className={("overviewbar", "mt30")}
                >
                  <Typography color="textPrimary" variant="body2">
                    {getDateTime(date)}
                  </Typography>
                </Grid>
              );
            })}
          </Typography> */}
          </AccordionDetails>
        </Accordion>

        <Accordion className="accordian">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography className={classes.heading}>Referrals Shared</Typography>
            <div>{referralsShared}</div>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      Date
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      {referralsSharedDates.map((date, inx) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            style={{ marginTop: 20 }}
                            key={inx + "dt"}
                          >
                            <Typography color="textPrimary" variant="body2">
                              {getDate(date["createddt"])}
                            </Typography>
                          </Grid>
                        );
                      })}

                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* <Typography className={classes.heading}>
            Date
            {referralsSharedDates.map((date, inx) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: 20 }}
                  key={inx + "dt"}
                >
                  <Typography color="textPrimary" variant="body2">
                    {getDate(date["createddt"])}
                  </Typography>
                </Grid>
              );
            })}
          </Typography> */}
          </AccordionDetails>
        </Accordion>

        <Accordion className="accordian">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={classes.heading}>
              Referees visits or downloads
            </Typography>
            <div>{refereesVisitsCount}</div>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User Id</TableCell>
                    <TableCell>Response</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      {refereeVisitsUserIDs.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "refereeVisitsUserIDs"}
                          >
                            <Grid item xs={12} sm={6} md={6}>
                              <Typography color="textPrimary" variant="body2">
                                {data.UserID}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>

                    <TableCell>
                      {refereeVisitsUserIDs.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "refereeVisitsUserIDs"}
                          >
                            <Grid item xs={12} sm={6} md={6}>
                              <Typography color="textPrimary" variant="body2">
                                {data["Sign Up"]}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* <Typography className={classes.heading}>
            User Id
            {refereeVisitsUserIDs.map((data, inx) => {
              return (
                <Grid
                  container
                  style={{ marginTop: 20 }}
                  key={inx + "refereeVisitsUserIDs"}
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography color="textPrimary" variant="body2">
                      {data.UserID}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Typography>
          <Typography className={classes.heading}>
            Response
            {refereeVisitsUserIDs.map((data, inx) => {
              return (
                <Grid
                  container
                  style={{ marginTop: 20 }}
                  key={inx + "refereeVisitsUserIDs"}
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography color="textPrimary" variant="body2">
                      {data["Sign Up"]}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Typography> */}
          </AccordionDetails>
        </Accordion>
        {/* </div>
      <div className="acc_parent2"> */}
        <Accordion className="accordian" style={{ width: 430 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography className={classes.heading}>
              Successful Referrals
            </Typography>
            <div>{successfulReferralsCount}</div>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      Amount
                    </TableCell>
                    <TableCell>
                      Date and Time
                    </TableCell>
                    <TableCell>
                      User Id
                    </TableCell>
                    <TableCell>
                      Subscription Status
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      {successfulReferralsData.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "successfulReferralsData"}
                          >
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography color="textPrimary" variant="body2">
                                &#8377; {data.Amount}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>
                    <TableCell>
                      {successfulReferralsData.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "successfulReferralsData"}
                          >
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography color="textPrimary" variant="body2">
                                {getDateTime(data["Datetime"])}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>
                    <TableCell>{successfulReferralsData.map((data, inx) => {
                      return (
                        <Grid
                          container
                          style={{ marginTop: 20 }}
                          key={inx + "successfulReferralsData"}
                        >
                          <Grid item xs={12} sm={4} md={4}>
                            <Typography color="textPrimary" variant="body2">
                              {data.UserID}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    })}</TableCell>
                    <TableCell>
                      {referralHistory.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "referralHistory"}
                          >
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography color="textPrimary" variant="body2">
                                {data["Status"]}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            {/* <Typography className={classes.heading}>
            Amount
            {successfulReferralsData.map((data, inx) => {
              return (
                <Grid
                  container
                  style={{ marginTop: 20 }}
                  key={inx + "successfulReferralsData"}
                >
                  <Grid item xs={12} sm={4} md={4}>
                    <Typography color="textPrimary" variant="body2">
                      {data.UserID}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Typography>
          <Typography className={classes.heading}>
            Date and Time
            {successfulReferralsData.map((data, inx) => {
              return (
                <Grid
                  container
                  style={{ marginTop: 20 }}
                  key={inx + "successfulReferralsData"}
                >
                  <Grid item xs={12} sm={4} md={4}>
                    <Typography color="textPrimary" variant="body2">
                      {getDateTime(data["Datetime"])}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Typography>
          <Typography className={classes.heading}>
            User Id
            {successfulReferralsData.map((data, inx) => {
              return (
                <Grid
                  container
                  style={{ marginTop: 20 }}
                  key={inx + "successfulReferralsData"}
                >
                  <Grid item xs={12} sm={4} md={4}>
                    <Typography color="textPrimary" variant="body2">
                      {data.UserID}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Typography>
          <Typography className={classes.heading}>
            Subscription Status
            {successfulReferralsData.map((data, inx) => {
              return (
                <Grid
                  container
                  style={{ marginTop: 20 }}
                  key={inx + "successfulReferralsData"}
                >
                  <Grid item xs={12} sm={4} md={4}>
                    <Typography color="textPrimary" variant="body2">
                      {data["UserID"]}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Typography> */}
          </AccordionDetails>
        </Accordion>

        <Accordion className="accordian" >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5a-content"
            id="panel5a-header"
          >
            <Typography className={classes.heading}>Referral bonus history</Typography>
            <div>&#8377; {totalAmount["earnings__sum"]}</div>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Amount</TableCell>
                    <TableCell>Date and Time</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      {referralHistory.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "referralHistory"}
                          >
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography color="textPrimary" variant="body2">
                                <div>
                                  &#8377;  {data.Amount}
                                </div>
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>

                    <TableCell>
                      {referralHistory.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "referralHistory"}
                          >
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography color="textPrimary" variant="body2">
                                {getDateTime(data["DateTime"])}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>

                    <TableCell>
                      {referralHistory.map((data, inx) => {
                        return (
                          <Grid
                            container
                            style={{ marginTop: 20 }}
                            key={inx + "referralHistory"}
                          >
                            <Grid item xs={12} sm={4} md={4}>
                              <Typography color="textPrimary" variant="body2">
                                {data["Status"]}
                              </Typography>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>


            {/* <Typography className={classes.heading}>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} sm={4} md={4}>
              <Typography color="textPrimary">
                Amount

                {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                  <div>
                    {data.Amount}
                  </div>
                  </Typography>
                </Grid>                
              </Grid>
            );
          })}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Typography color="textPrimary" className={classes.heading}>
                Date and Time
                <div>
                {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >                
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {getDateTime(data["DateTime"])}
                  </Typography>
                </Grid>                
              </Grid>
            );
          })}
          </div>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Typography color="textPrimary" className={classes.heading}>
                Status

                {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >                
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {data["Status"]}
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
              </Typography>
            </Grid>
          </Grid>.
          </Typography> */}
          </AccordionDetails>
        </Accordion>
      </div>


      {/* 
      <Grid container style={{ marginTop: 50 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography color="textPrimary" variant="caption">
              Referral bonus history
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Typography color="textPrimary" variant="h6">
              {totalAmount["earnings__sum"]}
            </Typography>
          </Grid>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} sm={4} md={4}>
              <Typography color="textPrimary" variant="body1">
                Amount
                {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {data.Amount}
                  </Typography>
                </Grid>                
              </Grid>
            );
          })}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Typography color="textPrimary" variant="body1">
                Date and Time
                {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >                
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {getDateTime(data["DateTime"])}
                  </Typography>
                </Grid>                
              </Grid>
            );
          })}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <Typography color="textPrimary" variant="body1">
                Status
                {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >                
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {data["Status"]}
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
              </Typography>
            </Grid>
          </Grid>
          {referralHistory.map((data, inx) => {
            return (
              <Grid
                container
                style={{ marginTop: 20 }}
                key={inx + "referralHistory"}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {data.Amount}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {getDateTime(data["DateTime"])}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <Typography color="textPrimary" variant="body2">
                    {data["Status"]}
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid> */}
    </Grid>
  );
}

export default ReferralDashboard;
